<template>
<v-menu offset-y slide-y :close-on-content-click="false">
  <template #activator="{ on, attrs }">
    <div v-on="on" v-bind="attrs" @click="load">
      <v-badge
        overlap
        class="ml-5"
        :content="len"
        :value="len"
        :color="len ? 'green' : 'gray'"
      >
        <v-icon color="gray">mdi-bell</v-icon>
      </v-badge>
    </div>
  </template>
  <v-list>
    <v-list-item v-if="!len" class="text-center">
      <em>No Unread Notifications</em>
    </v-list-item>
    <template v-for="(notif, i) in notifications">
    <v-divider v-if="i !== 0" :key="'notif-divider' + notif.id" />
    <v-list-item two-line :key="'notif' + notif.id">
      <v-list-item-content>
        <v-list-item-subtitle>
          {{ $moment(notif.date).fromNow() }}
        </v-list-item-subtitle>
        <v-list-item-title>
          <router-link :to="{name: 'User', params: {id: notif.suggester_id}}">
            {{ notif.suggester_name }}
          </router-link>
          has suggested
          <router-link :to="{name: 'Film', params: {id: notif.film_id}}">
            {{ notif.film_title }}
          </router-link>
          to you.
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click="mark(notif.id)">
          <v-icon large color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    </template>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: "NotificationMenu",
  data() {
    return {
      notifications: [],
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.load()
  },
  computed: {
    len() {
      return this.notifications.length
    },
  },
  methods: {
    async load() {
      this.notifications = await this.httpClient.loadNotifications()
    },
    async mark(id) {
      await this.httpClient.markNotificationAsRead({id})
      this.notifications = this.notifications.filter(n => n.id != id)
    },
  },
}
</script>
